/** Query keys for the campaign contacts table, optionally scoped to an entity. */
export const campaignContactKeys = {
  all: ["campaign-contacts"],
  lists: () => [...campaignContactKeys.all, "list"],
  list: ({ campaignId = null, entityId = null } = {}) => [
    ...campaignContactKeys.lists(),
    { campaignId, entityId },
  ],
};
